<template>
  <v-list
    v-if="field.value.length"
    class="filter-hover-list"
    density="compact"
  >
    <v-list-item
      v-for="(activeFilter, index) in field.value"
      :key="index"
      class="menu-list-item text-left"
    >
      <p>{{ activeFilter.label }}</p>
    </v-list-item>
    <v-divider />
  </v-list>
</template>

<script>
export default {
  name: 'FilterHoverList',
  props: {
    field: { type: Object, default: () => ({}) },
  },
};
</script>

<style lang="less" scoped>
@import '@/less/mixins';
.v-menu__content {
  .shadow();
}
.filter-hover-list {
  max-height: 352px;
  overflow: auto;
}
.menu-list-item.v-list-item {
  border-bottom: 1px solid @stroke-default;
  min-height: 40px;
  height: 40px;
}
</style>
